import classNames from 'classnames';

import MealCardPlaceholder from 'components/icons/MealCardPlaceholder';
import style from 'styles/shared/dashboardMealCard';

const LoadingCard = () => (
  <MealCardPlaceholder className={classNames(style.loading, style.expanded)} />
);

export default LoadingCard;
